export default __webpack_public_path__ + "static/media/CAMACOL.4e7a1b44.jpg";